import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";

export const AdministratorGeneralAdmissionVenueEventTicketTypes = () => {
    const dispatch = useDispatch();

    const [ticketTypes, setTicketTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [totalTicketTypeCount, setTotalTicketTypeCount] = useState(0);

    const initialPageState = {
        skip: 0,
        take: 20,
    };
    const [page, setPage] = useState(initialPageState);
    const pageChange = (event) => {
        setPage(event.page);
    };

    const getTicketTypes = () => {
        setIsLoading(true);

        const dataItem = {
            
        };

        fetch(`/api/administrator/generaladmissionvenueeventtickettypes`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setTicketTypes(result);
                setTotalTicketTypeCount(result.length);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getGridData = () => {
        return ticketTypes.slice(page.skip, page.take + page.skip);
    };

    useEffect(() => {
        document.title = "GA Ticket Types";

        getTicketTypes();
    }, []);

    return (
        <div className="administratorReport">
            {isLoading ? <LoadingPanel /> : <></>}

            <Grid
                data={getGridData()}
                resizable={true}
                skip={page.skip}
                take={page.take}
                total={totalTicketTypeCount}
                pageable={true}
                onPageChange={pageChange}
                scrollable="none"
            >
                <Column field="name" title={"Name"} />
                <Column field="count" title={"Count"} />
            </Grid>
        </div>
    );
}